"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BulkUploadErrorList;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _withAPIData = require("alpaca.js/dist/api/withAPIData");

var _axios = _interopRequireDefault(require("axios"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _loadingWrapper = _interopRequireDefault(require("../util/loadingWrapper"));

var _reactstrap = require("reactstrap");

var _informed = require("informed");

var _bootstrap = require("../autoform/bootstrap");

var _immutableSetter = require("immutable-setter");

var _fa = _interopRequireDefault(require("../util/fa"));

var _loadingButton = _interopRequireDefault(require("../util/loadingButton"));

var _file_uploader = _interopRequireDefault(require("./file_uploader"));

var _index = require("./index");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BulkUploadErrorRow = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(BulkUploadErrorRow, _Component);

  var _super = _createSuper(BulkUploadErrorRow);

  function BulkUploadErrorRow(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, BulkUploadErrorRow);
    _this = _super.call(this, props);
    _this.onDelete = _this.onDelete.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderColumn = _this.renderColumn.bind((0, _assertThisInitialized2["default"])(_this));
    _this.uploadComplete = _this.uploadComplete.bind((0, _assertThisInitialized2["default"])(_this));
    _this.uploadStart = _this.uploadStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.uploadComplete = _this.uploadComplete.bind((0, _assertThisInitialized2["default"])(_this));
    _this.removeFile = _this.removeFile.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      collapsed: false,
      deleting: false,
      deleted: false,
      uploading: 0
    };
    return _this;
  }

  (0, _createClass2["default"])(BulkUploadErrorRow, [{
    key: "onDelete",
    value: function onDelete() {
      this.setState({
        deleting: true
      });
      var component = this;
      this.props.axiosInstance["delete"](this.props.url, {
        params: {
          id: this.props.row.id
        }
      }).then(function () {
        component.setState({
          deleting: false,
          deleted: true
        });
      });
    }
  }, {
    key: "uploadStart",
    value: function uploadStart() {
      this.setState({
        uploading: this.state.uploading + 1
      });
    }
  }, {
    key: "uploadComplete",
    value: function uploadComplete(fileData) {
      var row = this.props.row;
      var last_row = row.data.documentation ? row.data.documentation.length : 0;
      this.setState({
        uploading: this.state.uploading - 1
      });
      this.props.setRow((0, _immutableSetter.setIn)(row.data.documentation, [last_row], fileData));
    }
  }, {
    key: "removeFile",
    value: function removeFile(file_index) {
      var d = this.props.row.data.documentation.slice();
      d.splice(file_index, 1);
      this.props.setRow(d);
    }
  }, {
    key: "renderColumn",
    value: function renderColumn(v, key) {
      var _this2 = this;

      var _this$props = this.props,
          row = _this$props.row,
          columnFormatters = _this$props.columnFormatters,
          readOnlyColumns = _this$props.readOnlyColumns;

      var readOnly = _.includes(readOnlyColumns, key);

      var value = columnFormatters[key] !== undefined ? columnFormatters[key](row.data[key]) : row.data[key];
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: "row-".concat(row.id, "-").concat(key)
      }, readOnly ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        readOnly: true,
        className: "form-control-plaintext",
        value: value
      })) : key == "documentation" ? /*#__PURE__*/_react["default"].createElement(_file_uploader["default"], {
        pdfServiceUrl: this.props.fileUploadUrl,
        files: row.data.documentation,
        onUploadStart: this.uploadStart,
        onUploadComplete: function onUploadComplete(fileData) {
          return _this2.uploadComplete(fileData);
        },
        onRemoveFile: function onRemoveFile(file_index) {
          _this2.removeFile(file_index);
        },
        fileSizeTotalLimit: _index.MAX_FILE_SIZE,
        crmClient: this.props.crmClient,
        style: {
          fontSize: "11px",
          color: "#212529"
        }
      }) : /*#__PURE__*/_react["default"].createElement(_bootstrap.BootstrapText, {
        field: key,
        showLabel: false,
        error: row.errors[key],
        disabled: this.state.deleting
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          row = _this$props2.row,
          columns = _this$props2.columns,
          subSectionName = _this$props2.subSectionName,
          renderSubSection = _this$props2.renderSubSection,
          shouldRenderSubSection = _this$props2.shouldRenderSubSection;

      if (_.isFunction(shouldRenderSubSection)) {
        shouldRenderSubSection = shouldRenderSubSection(row);
      }

      if (this.state.deleted) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("tr", null, _.map(columns, this.renderColumn), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-link text-danger",
        type: "button",
        onClick: this.onDelete,
        disabled: this.state.deleting
      }, this.state.deleting ? /*#__PURE__*/_react["default"].createElement(_fa["default"], {
        icon: "spinner",
        spin: true
      }) : /*#__PURE__*/_react["default"].createElement(_fa["default"], {
        icon: "times",
        size: 1,
        title: "Delete Invoice"
      })))), shouldRenderSubSection && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: _.keys(columns).length,
        style: {
          borderTop: "none"
        },
        className: "pt-0"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();

          _this3.setState({
            collapsed: !_this3.state.collapsed
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_fa["default"], {
        icon: this.state.collapsed ? "chevron-down" : "chevron-up",
        className: "mr-2"
      }), this.state.collapsed ? "Show" : "Hide", " ", subSectionName), /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
        isOpen: !this.state.collapsed
      }, renderSubSection(row)))));
    } // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     // don't need to re-render ever because the form stores it's own state
    //     return nextState.collapsed !== this.state.collapsed;
    // }

  }]);
  return BulkUploadErrorRow;
}(_react.Component);

var BulkUploadErrorListInner = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(BulkUploadErrorListInner, _Component2);

  var _super2 = _createSuper(BulkUploadErrorListInner);

  function BulkUploadErrorListInner(props) {
    var _this4;

    (0, _classCallCheck2["default"])(this, BulkUploadErrorListInner);
    _this4 = _super2.call(this, props);
    _this4.doUpload = _this4.doUpload.bind((0, _assertThisInitialized2["default"])(_this4));
    _this4.mergeData = _this4.mergeData.bind((0, _assertThisInitialized2["default"])(_this4));
    _this4.state = {
      data: props.data,
      loading: false
    };
    return _this4;
  }

  (0, _createClass2["default"])(BulkUploadErrorListInner, [{
    key: "doUpload",
    value: function doUpload(data) {
      var _this$props3 = this.props,
          axiosInstance = _this$props3.axiosInstance,
          url = _this$props3.url,
          onUpload = _this$props3.onUpload;

      var realData = _.map(data, function (row) {
        return _objectSpread({
          _bulk_upload_error_id: row.id
        }, row.data);
      });

      this.setState({
        loading: true
      });
      axiosInstance.put(url, realData).then(function (response) {
        onUpload(response);
      });
    }
  }, {
    key: "setRow",
    value: function setRow(index, data) {
      this.setState({
        data: (0, _immutableSetter.setIn)(this.state.data, [index, "data", "documentation"], data)
      });
    }
  }, {
    key: "mergeData",
    value: function mergeData(data) {
      var _this5 = this;

      Object.keys(data).map(function (index) {
        var r = _this5.state.data[index];
        data[index].data["documentation"] = r.data.documentation;
      });
      this.doUpload(data);
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props4 = this.props,
          columns = _this$props4.columns,
          subSectionName = _this$props4.subSectionName,
          renderSubSection = _this$props4.renderSubSection,
          shouldRenderSubSection = _this$props4.shouldRenderSubSection,
          readOnlyColumns = _this$props4.readOnlyColumns,
          columnFormatters = _this$props4.columnFormatters;
      var data = this.state.data;
      return /*#__PURE__*/_react["default"].createElement(_informed.Form, {
        initialValues: data,
        onSubmit: this.mergeData
      }, function (_ref) {
        var formState = _ref.formState;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Table, null, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, _.map(columns, function (value, key) {
          return /*#__PURE__*/_react["default"].createElement("th", {
            className: "th-" + key,
            key: key
          }, value);
        }), /*#__PURE__*/_react["default"].createElement("th", {
          width: "35"
        }))), /*#__PURE__*/_react["default"].createElement("tbody", null, _.map(data, function (row, index) {
          return /*#__PURE__*/_react["default"].createElement(_informed.Scope, {
            scope: "[".concat(index, "].data"),
            key: "row-".concat(index)
          }, /*#__PURE__*/_react["default"].createElement(BulkUploadErrorRow, {
            row: row,
            index: index,
            columns: columns,
            axiosInstance: _this6.props.axiosInstance,
            url: _this6.props.url,
            fileUploadUrl: "/invoice_documentation/",
            subSectionName: subSectionName,
            renderSubSection: renderSubSection,
            shouldRenderSubSection: shouldRenderSubSection,
            readOnlyColumns: readOnlyColumns,
            columnFormatters: columnFormatters,
            crmClient: _this6.props.crmClient,
            setRow: _this6.setRow.bind(_this6, index)
          }));
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "text-center mt-4"
        }, /*#__PURE__*/_react["default"].createElement(_loadingButton["default"], {
          type: "submit",
          loading: _this6.state.loading,
          color: "primary",
          className: "btn-wide",
          size: "lg"
        }, "Upload")));
      });
    }
  }]);
  return BulkUploadErrorListInner;
}(_react.Component);

function BulkUploadErrorList(props) {
  var url = props.url,
      axiosInstance = props.axiosInstance;
  return /*#__PURE__*/_react["default"].createElement(_withAPIData.WithAPIData, {
    axiosInstance: axiosInstance,
    url: url
  }, function (_ref2) {
    var data = _ref2.data,
        loading = _ref2.loading;
    return /*#__PURE__*/_react["default"].createElement(_loadingWrapper["default"], {
      loading: loading
    }, /*#__PURE__*/_react["default"].createElement(BulkUploadErrorListInner, (0, _extends2["default"])({}, props, {
      data: data
    })));
  });
}

BulkUploadErrorList.propTypes = {
  axiosInstance: _propTypes["default"].func.isRequired,
  url: _propTypes["default"].string.isRequired,
  subSectionName: _propTypes["default"].string,
  shouldRenderSubSection: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
  renderSubSection: _propTypes["default"].func,
  onUpload: _propTypes["default"].func.isRequired,
  columnFormatters: _propTypes["default"].objectOf(_propTypes["default"].func),
  crmClient: _propTypes["default"].func
};
BulkUploadErrorList.defaultProps = {
  axiosInstance: _axios["default"],
  shouldRenderSubSection: false,
  subSectionName: "Details",
  readOnlyColumns: [],
  columnFormatters: {}
};